import { Listing, Pagination } from 'src/app/shared/models';

export interface SharedState {
  properties: Listing[];
  primeProperties: Listing[];
  recommendedProperties: Listing[];
  pagination: Pagination;
  primePropertiesLoading: boolean;
  error: any;
}

export const initialState: SharedState = {
  properties: null,
  primeProperties: null,
  recommendedProperties: null,
  primePropertiesLoading: false,
  error: null,
  pagination: null,
};
